export default "__VITE_ASSET__BGdLtmZ8__"